import { Card, Col, Descriptions, Flex, Row, Spin, Tag } from "antd";
import {
  UserOutlined,
  ShareAltOutlined,
  CalendarOutlined,
  BarChartOutlined,
  CheckCircleOutlined,
  AppstoreAddOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import useWorkflowList from "../entity/api/workflow-list";
import styled from "styled-components";
const { Item } = Descriptions;
export default function WorkflowList() {
  const { data, isLoading, error } = useWorkflowList();

  if (isLoading)
    return (
      <Flex align="center" justify="center" gap="middle">
        <Spin indicator={<LoadingOutlined spin />} size="large" />
      </Flex>
    );
  if (error)
    return (
      <Flex align="center" justify="center" gap="middle">
        <div>Error: {error.message}</div>
      </Flex>
    );

  const descriptionItems = [
    {
      icon: <UserOutlined />,
      label: "Workflow Owner",
      valueKey: "workflowOwner",
    },
    {
      icon: <ShareAltOutlined />,
      label: "Collaborated By",
      valueKey: "collaboratedBy",
    },
    { icon: <CalendarOutlined />, label: "Due Date", valueKey: "dueDate" },
    { icon: <BarChartOutlined />, label: "Progress", valueKey: "progress" },
    { icon: <AppstoreAddOutlined />, label: "Task", valueKey: "task" },
    { icon: <CheckCircleOutlined />, label: "Interval", valueKey: "interval" },
  ];

  return (
    <Row gutter={[16, 16]}>
      {data?.map((workflow) => (
        <Col key={workflow?.workflowId || Math.random()} span={8}>
          <Card
            loading={isLoading}
            title={workflow?.workflowName}
            extra={<Tag color="green">{workflow?.frequency}</Tag>}
          >
            <Descriptions layout="vertical" column={2}>
              {descriptionItems.map(({ icon, label, valueKey }) => (
                <Item
                  key={valueKey}
                  label={<IconWithLabel icon={icon} label={label} />}
                >
                  <StyeledItem> {workflow?.[valueKey] || "-"}</StyeledItem>
                </Item>
              ))}
            </Descriptions>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

const IconWithLabel = ({ icon, label }) => (
  <Flex align="center" justify="center">
    <IconWithBox>{icon}</IconWithBox>
    <div>{label}</div>
  </Flex>
);

const IconWithBox = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: #f5ad1d;
  color: white;
  padding: 4px;
  border-radius: 4px;
  margin-right: 8px;
  font-size: 16px;
`;

const StyeledItem = styled.div`
  padding-left: 28px;
`;
